import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconV2, Tooltip, Typography } from "@bookips/sds";
import { useState } from "react";
// SDS Tooltip은 hover 전용이라 모바일 미동작 → controlled open으로 click 토글까지 커버
const PendingTooltipButton = (param)=>{
    let { description , onOpenChange  } = param;
    const [open, setOpen] = useState(false);
    const handleOpenChange = (next)=>{
        setOpen(next);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(next);
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        open: open,
        onOpenChange: handleOpenChange,
        description: description,
        side: "bottom",
        showArrow: true,
        align: "start",
        sideOffset: -10,
        bold: true,
        size: "sm",
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            onClick: ()=>handleOpenChange(!open),
            className: "flex items-center gap-1",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    className: "text-secondary",
                    children: "사용 대기"
                }),
                /*#__PURE__*/ _jsx(IconV2.InfoCircle, {
                    size: "xxs",
                    className: "text-secondary"
                })
            ]
        })
    });
};
export default PendingTooltipButton;
